import { watch } from 'vue'
import { useI18n } from 'vue-i18n'

export function useHtmlLang() {
  const { locale } = useI18n()

  watch(
    locale,
    (newLocale) => {
      document.documentElement.lang = newLocale
    },
    { immediate: true }
  )
}
